export const sitesWebMisc = {
  // NombreEditable.vue — inline-editable website name field
  ne: {
    aria: "Your website name",
    placeholder: "My accommodation",
    hint: "Enter to save · Esc to cancel",
  },

  // website/index.vue — website creation wizard
  website: {
    next: "Next",
  },

  // Notificaciones/index.vue — notifications timeline
  notif: {
    title: "Notifications",
    subtitle: "Everything that has happened across your accommodations, in chronological order.",
    // Filters
    filterAll: "All",
    filterBookings: "Bookings",
    filterCheckins: "Check-ins",
    filterServices: "Services",
    filterPayments: "Payments",
    // Empty state
    emptyAll: "No notifications yet",
    emptyFilter: "No notifications in this filter",
    emptyBody:
      "When something happens with your bookings —a new one, a check-in, a payment— it will show up here.",
    // Day separators
    noDate: "No date",
    today: "Today",
    yesterday: "Yesterday",
    // Event status (left column)
    stNueva: "New",
    stActualizada: "Updated",
    stCancelada: "Cancelled",
    stRealizado: "Completed",
    stSolicitado: "Requested",
    stRecibida: "Received",
    stAprobada: "Approved",
    stRechazada: "Rejected",
    stConfirmado: "Confirmed",
    stEnProceso: "Payment in progress",
    stAviso: "Notice",
    // Event category (subtitle)
    catReserva: "booking",
    catCheckin: "check-in",
    catServicio: "service",
    catSolicitud: "request",
    catPago: "payment",
    catPagoPendiente: "pending payment",
    catSistema: "system",
    // Descriptive event-type labels
    lbNuevaReserva: "New booking",
    lbReservaActualizada: "Booking updated",
    lbReservaCancelada: "Booking cancelled",
    lbCheckin: "Check-in",
    lbServicio: "Service",
    lbSolicitud: "Request",
    lbSolicitudAprobada: "Request approved",
    lbSolicitudRechazada: "Request rejected",
    lbPago: "Payment",
    lbNotificacion: "Notification",
  },

  // Integrations/index.vue — integrations with external services
  integrations: {
    title: "Integrations",
    subtitle: "Connect external services to streamline management",
    descPricelabs: "Dynamic price optimization",
    descStripe: "Card payments from guests",
    descWompi: "Guest payments in Colombia",
    connected: "Connected",
    disconnected: "Not connected",
  },
};
